import {withFormsy} from 'formsy-react';
import React, {useState} from 'react';

let RatingFormInput = (props) => {

    const getRatingClass = () => {
        return props.getValue() ? `rating-${parseInt(props.getValue())}` : 'rating-none'
    }

    const [formId, setFormId] = useState(TB.guid());

    const [hoverValue, setHoverValue] = useState(null);

    const [activeBgClass, setActiveBgClass] = useState(getRatingClass())


    let values = TB.range(1, 6)
        .map(year => {
                return {
                    label: String(year),
                    value: year
                };
            }
        );

    let inputValue = props.getValue() || false

    return (
        <div className={'form-group ' + (props.className || '')}>
            {props.label !== false && (
                <label className="col-form-label">
                    {props.label}
                </label>
            )}
            <input type="hidden" name={props.name} value={inputValue || ''}/>
            <div className="rating-form-group" onMouseLeave={() => {
                setHoverValue(null)
                setActiveBgClass(getRatingClass())
            }}>
                {TB.map(values, ({label, value}) => (
                    <div key={TB.slugify(props.name + "-rating-" + value)}
                         onClick={() => {
                             setHoverValue(value)
                             props.setValue(value)
                         }}
                         onMouseEnter={() => {
                             if (!inputValue || parseInt(inputValue) <= value) {
                                 setHoverValue(value)
                             }
                         }}
                         className={TB.mapClass("rating-input", {
                             disabled: props.disabled,
                             active: parseInt(inputValue) === parseInt(value),
                             [activeBgClass]: activeBgClass && !hoverValue && parseInt(inputValue) >= parseInt(value),
                             ['rating-' + hoverValue]: hoverValue && parseInt(hoverValue) >= parseInt(value),
                         })
                         }>
                        <p>{label}</p>
                    </div>
                ))}

            </div>

        </div>
    )
};

const RatingInput = withFormsy(RatingFormInput);

export default RatingInput;